"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimDispenserControlEvseCommandsValidation = void 0;
class SimDispenserControlEvseCommandsValidation {
    static isValid(entity) {
        // Validate entity.hv_ps_enable for existence and correct type.
        if (entity.hv_ps_enable == undefined)
            return false;
        if (typeof entity.hv_ps_enable !== "boolean")
            return false;
        // Validate entity.hv_ps_desired_voltage_v for existence and correct type.
        if (entity.hv_ps_desired_voltage_v == undefined)
            return false;
        if (typeof entity.hv_ps_desired_voltage_v !== "number")
            return false;
        // Validate entity.hv_ps_desired_current_a for existence and correct type.
        if (entity.hv_ps_desired_current_a == undefined)
            return false;
        if (typeof entity.hv_ps_desired_current_a !== "number")
            return false;
        // Validate entity.contactor_en for existence and correct type.
        if (entity.contactor_en == undefined)
            return false;
        if (typeof entity.contactor_en !== "boolean")
            return false;
        // Validate entity.drift_en for existence and correct type.
        if (entity.drift_en == undefined)
            return false;
        if (typeof entity.drift_en !== "boolean")
            return false;
        // Validate entity.ovp_lim_v for existence and correct type.
        if (entity.ovp_lim_v == undefined)
            return false;
        if (typeof entity.ovp_lim_v !== "number")
            return false;
        // Validate entity.ocp_lim_a for existence and correct type.
        if (entity.ocp_lim_a == undefined)
            return false;
        if (typeof entity.ocp_lim_a !== "number")
            return false;
        return true;
    }
}
exports.SimDispenserControlEvseCommandsValidation = SimDispenserControlEvseCommandsValidation;
